import React from 'react';
import { useApp } from '../context/AppContext';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import ScrollToTop from '../components/common/ScrollToTop';
import Toast from '../components/ui/Toast';
import InstallPWA from '../components/ui/InstallPWA';
import './MainLayout.css';

const MainLayout = ({ children }) => {
  const { state, hideToast } = useApp();

  return (
    <div className="main-layout">
      <a href="#main-content" className="skip-link">
        Saltar al contenido principal
      </a>
      <Header />
      <main id="main-content" className="main-content">
        {children}
      </main>
      <Footer />
      <ScrollToTop />
      <InstallPWA />
      {state.toast && (
        <Toast
          message={state.toast.message}
          type={state.toast.type}
          duration={state.toast.duration}
          isVisible={!!state.toast}
          onClose={hideToast}
        />
      )}
    </div>
  );
};

export default MainLayout;
